import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;

  @media (max-width: 1000px) {
    padding: 0;
  }
`;
